module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"connect":"Connect","password":"Password","userLogin":"Connection identifier"},"fr":{"connect":"Connexion","password":"Mot de passe","userLogin":"Identifiant de connexion"}}')
  delete Component.options._Ctor
}
